import type { ReactElement } from "react";

export const NavPhoneNumber = (): ReactElement => {
  return <>55&nbsp;55&nbsp;33&nbsp;33</>;
};
